import { stats } from '@fiverr-private/obs';

export const metric = stats.prefix('services.lising_orchestrator');
